import React from "react";
import { Route, Routes, Link } from "react-router-dom";
import Login from "./components/Login";
import Register from "./components/Register";
import Dashboard from "./components/Dashboard";
import Home from "./components/Home";
import MenuDisplay from "./components/MenuDisplay";
import SubscriptionPage from "./components/SubscriptionPage";
import CustomerOrderStatus from "./components/CustomerOrderStatus";
import CutomerDetails from "./components/CustomerDetails";
import VerifyEmail from "./components/VerifyEmail";
import Cart from "./components/Cart";
import AuthGuard from "./guard/AuthGuard";
import TrackOrder from "./components/TrackOrder";
import ResetPassword from "./components/ResetPassword";
import Contact from "./components/Contact";
import About from "./components/About";
import TermsAndConditions from "./components/TermsAndConditions";
import CustomerOrders from "./components/CustomerOrders";
import PaymentDetails from "./components/PaymentDetails";
import SubscriptionDetails from "./components/SubscriptionDetails";

const App = () => {
  const handleLogoClick = (e) => {
    e.preventDefault();

    // Clear authentication
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.clear(); // Clear all localStorage if needed

    // Force full page reload to home
    window.location.replace("/");
  };

  return (
    <div className="flex flex-col min-h-screen">
      {/* Header */}
      <header className="flex items-center justify-between p-4 bg-gray-100">
        <div className="flex items-center">
          <div
            onClick={handleLogoClick}
            className="flex items-center cursor-pointer"
          >
            <img
              src="/dflogo.png"
              alt="DineFaster Logo"
              className="h-10 md:h-12 w-auto cursor-pointer"
            />
            <h1 className="text-2xl md:text-4xl font-bold mx-3">Dinerspoint</h1>
          </div>
        </div>
      </header>
      {/* Main content */}
      <main className="flex-grow">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard/register" element={<Register />} />
          <Route
            path="/dashboard/*"
            element={<AuthGuard component={<Dashboard />} />}
          />
          <Route path="/menu-display" element={<MenuDisplay />} />
          <Route
            path="/select-subscription"
            element={<AuthGuard component={<SubscriptionPage />} />}
          />
          <Route path="/register" element={<Register />} />
          <Route path="/track-order" element={<TrackOrder />} />
          <Route path="/customer_details" element={<CutomerDetails />} />
          <Route path="/customer_orders" element={<CustomerOrders />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route
            path="/customer/order-status"
            element={<CustomerOrderStatus />}
          />
          <Route
            path="/payment-details"
            element={<AuthGuard component={<PaymentDetails />} />}
          />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route
            path="/subscription-details"
            element={<SubscriptionDetails />}
          />
        </Routes>
      </main>

      {/* Footer */}
      <footer className="bg-gray-100 p-3 md:p-4 text-center text-sm md:text-base w-full">
        <p className="text-gray-600 mb-2">
          © 2024 Restaurant Table-Server-Assist. All rights reserved.
        </p>
        <div className="flex flex-wrap justify-center gap-3 text-blue-500">
          <Link to="/" className="hover:underline">
            Home
          </Link>
          <span>|</span>
          <Link to="/contact" className="hover:underline">
            Contact Us
          </Link>
          <span>|</span>
          <Link to="/about" className="hover:underline">
            About Us
          </Link>
          <span>|</span>
          <Link to="/terms-and-conditions" className="hover:underline">
            Terms
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default App;
